<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex fxLayout="column" style="overflow: auto" class="mainContentBodyContent">
    <h2>Sondaggi</h2>
    <p>Imposta i filtri di ricerca</p>
    <div fxLayout="column" class="responsive-mat-form">

      <!-- Titolo sondaggio -->
      <mat-form-field fxlayout="column" >
        <mat-label >Cerca per titolo</mat-label>
        <input matInput [(ngModel)]="parameters.titolo" placeholder="Cerca per titolo">
      </mat-form-field>

      <!-- Creatore  -->
      <mat-form-field>
        <mat-select name="creatore" [(ngModel)]="parameters.creatore" [compareWith]='compareDTO'
          placeholder="Scegli il creatore"
          (selectionChange)="this.parameters.collaboratoreChanged = true">
          <mat-option [value]="null">
            Tutti
          </mat-option>
          <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
            {{collaboratore.nome}} {{collaboratore.cognome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Date creazione -->
      <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" class="responsive-mat-form">
        <!-- DataCreazioneDa  -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
          [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
          [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
          <input matInput readonly="true" (click)="picker.open()" [(max)]="parameters.dataCreazioneA"
            [(ngModel)]="parameters.dataCreazioneDa" [matDatepicker]="picker" placeholder="Scegli data creazione da">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <button mat-button *ngIf="parameters.dataCreazioneDa" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataCreazioneDa=null">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- DataCreazioneA  -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <input matInput readonly="true" (click)="picker2.open()" [(min)]="parameters.dataCreazioneDa"
            [(ngModel)]="parameters.dataCreazioneA" [matDatepicker]="picker2" placeholder="Scegli data creazione a">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <button mat-button *ngIf="parameters.dataCreazioneA" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataCreazioneA=null">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Date scadenza -->
      <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" class="responsive-mat-form">
        <!-- DataScadenzaDa -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
          [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
          [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
          <input matInput readonly="true" (click)="picker3.open()" [(max)]="parameters.dataScadenzaA"
            [(ngModel)]="parameters.dataScadenzaDa" [matDatepicker]="picker3" placeholder="Scegli data scadenza da">
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
          <button mat-button *ngIf="parameters.dataScadenzaDa" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataScadenzaDa=null">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- DataScadenzaA -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <input matInput readonly="true" (click)="picker4.open()" [(min)]="parameters.dataScadenzaDa"
            [(ngModel)]="parameters.dataScadenzaA" [matDatepicker]="picker4" placeholder="Scegli data scadenza a">
          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
          <mat-datepicker #picker4></mat-datepicker>
          <button mat-button *ngIf="parameters.dataScadenzaA" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataScadenzaA=null">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Risposta multipla -->
      <mat-form-field>
        <mat-select name="rispostaMultipla" [(ngModel)]="parameters.rispostaMultipla" placeholder="Seleziona il tipo di risposta"
          (selectionChange)="this.parameters.collaboratoreChanged = true">
          <mat-option [value]="null"> Tutti </mat-option>
          <mat-option [value]="true"> Risposta multipla </mat-option>
          <mat-option [value]="false"> Risposta singola </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-card-actions>
      <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
      <button mat-raised-button id="new-button" [routerLink]="['/creazione-sondaggi/detail/0']">New</button>
    </mat-card-actions>

    <br />

    <div *ngIf="parameters.showList" fxLayout="column">
      <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()" matSort
        (matSortChange)="setSort($event)" matSortDisableClear [dataSource]="parameters.dataSource">

        <!-- Id Column -->
        <ng-container matColumnDef="id">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Id sondaggio </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio"> {{sondaggio.id}} </td>
        </ng-container>

        <!-- titolo Column -->
        <ng-container matColumnDef="titolo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titolo </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.titolo}}</td>
        </ng-container>

        <!-- descrizione Column -->
        <ng-container matColumnDef="descrizione">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.descrizione}}</td>
        </ng-container>

        <!-- Creatore Column -->
        <ng-container matColumnDef="creatore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Creatore </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.creatore?.nome}}
            {{sondaggio.creatore?.cognome}} </td>
        </ng-container>

        <!-- dataCreazione Column -->
        <ng-container matColumnDef="dataCreazione">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data creazione </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.insertDate | date :'dd/MM/yyyy'}} </td>
        </ng-container>

        <!-- dataScadenza Column -->
        <ng-container matColumnDef="dataScadenza">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data scadenza  </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.dataScadenza | date :'dd/MM/yyyy'}} </td>
        </ng-container>

        <!-- rispostaMultipla Column -->
        <ng-container matColumnDef="isMultiple">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Risposta multipla </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio" > 
            <span *ngIf="sondaggio.numMaxRisposte > 1">Sì (max {{sondaggio.numMaxRisposte}})</span>
            <span *ngIf="sondaggio.numMaxRisposte == 1">No</span>
            <span *ngIf="sondaggio.numMaxRisposte < 1">???</span>
          </td>
        </ng-container>

        <!-- rispostePresenti Column -->
        <ng-container matColumnDef="rispostePresenti">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Risposte presenti </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio" > 
            <span>{{ numRisposte(sondaggio) }}</span>
          </td>
        </ng-container>

        <!-- votanti Column -->
        <ng-container matColumnDef="votanti">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Votanti </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio" > 
            <span>{{ votanti(sondaggio) }}</span>
          </td>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="detail">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let sondaggio">
            <div fxLayout="row" fxLayoutAlign="space-evenly center">
              <button mat-mini-fab color="primary" matTooltip="Dettagli" [routerLink]="['/creazione-sondaggi/detail/', sondaggio.id]">
                <mat-icon>search</mat-icon>
              </button>
              <button mat-mini-fab color="primary" matTooltip="Risultati" [routerLink]="['/risultati-sondaggio/', sondaggio.id] ">
                <mat-icon>pie_chart</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-actions>
          <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'sondaggio'})">Excel</button>
          <button fxHide fxShow.gt-md mat-raised-button
            (click)="exporter.exportTable('csv', {fileName:'sondaggio'})">Csv</button>
          <button fxHide fxShow.gt-md mat-raised-button
            (click)="exporter.exportTable('json', {fileName:'sondaggio'})">Json</button>
        </mat-card-actions>
        <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length"
          [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>